/**
 * @generated SignedSource<<981ec410bd77d6566755341314252a5a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationType = "API" | "SHOP_N_COLLECT" | "THALIA" | "%future added value";
export type PickupStatus = "BLOCKED" | "COLLECTED" | "COLLECTING" | "CONFIRMED" | "EXPIRED" | "PENDING" | "%future added value";
export type clickncollectQuery$variables = {
  pickupId: string;
};
export type clickncollectQuery$data = {
  readonly pickup: {
    readonly customer: {
      readonly email: string;
      readonly id: string;
      readonly phoneNumber: string | null | undefined;
      readonly user: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    };
    readonly hub: {
      readonly id: string;
      readonly meta: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly spaces: ReadonlyArray<{
        readonly frame: string;
        readonly id: string;
      }>;
    };
    readonly id: string;
    readonly orderItems: ReadonlyArray<{
      readonly id: string;
      readonly order: {
        readonly id: string;
        readonly source: IntegrationType;
      };
    }>;
    readonly reservation: {
      readonly id: string;
      readonly space: {
        readonly frame: string;
        readonly id: string;
      };
    };
    readonly status: PickupStatus;
  };
};
export type clickncollectQuery = {
  response: clickncollectQuery$data;
  variables: clickncollectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pickupId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "pickupId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "OrderItem",
  "kind": "LinkedField",
  "name": "orderItems",
  "plural": true,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Order",
      "kind": "LinkedField",
      "name": "order",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "source",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  (v2/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v6 = [
  (v2/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "frame",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "HubMeta",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": (v5/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "spaces",
      "plural": true,
      "selections": (v6/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Customer",
  "kind": "LinkedField",
  "name": "customer",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": (v5/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "ClickNCollectReservation",
  "kind": "LinkedField",
  "name": "reservation",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": (v6/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "clickncollectQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "Pickup",
          "kind": "LinkedField",
          "name": "pickup",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            (v4/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": (v7/*:: as any*/),
              "action": "THROW"
            },
            {
              "kind": "RequiredField",
              "field": (v8/*:: as any*/),
              "action": "THROW"
            },
            {
              "kind": "RequiredField",
              "field": (v9/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "clickncollectQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Pickup",
        "kind": "LinkedField",
        "name": "pickup",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a30de58fda569cc5d56e09282e0627a3",
    "id": null,
    "metadata": {},
    "name": "clickncollectQuery",
    "operationKind": "query",
    "text": "query clickncollectQuery(\n  $pickupId: UUID!\n) {\n  pickup(id: $pickupId) {\n    id\n    status\n    orderItems {\n      id\n      order {\n        id\n        source\n      }\n    }\n    hub {\n      id\n      meta {\n        id\n        name\n      }\n      spaces {\n        id\n        frame\n      }\n    }\n    customer {\n      id\n      email\n      phoneNumber\n      user {\n        id\n        name\n      }\n    }\n    reservation {\n      id\n      space {\n        id\n        frame\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c7cbeae3b53b35d4e11e573b724a0b3";

export default node;
